<div class='w-100 h-100 background'>
  <div class='card p-5'>
    <app-first-factor *ngIf='loginHttp.activeStep === 0'></app-first-factor>
    <app-qr-code *ngIf='loginHttp.activeStep === 1'></app-qr-code>
    <app-second-factor *ngIf='loginHttp.activeStep === 2'></app-second-factor>
    <app-already-logged-in [user]='user' *ngIf='user && loginHttp.activeStep === 3'>
    </app-already-logged-in>
  </div>
</div>
